import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Paper, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import usePaymentSettings from 'components/context/PaymentSettings/usePaymentSettings';
import PaymentFormContent from './PaymentFormContent';
import useBookingHistoryDetails from 'queries/Booking/useBookingHistoryDetails';
import { useIsDesktop, useTranslations } from 'components/utilities';

const PaymentForm = () => {
	const { bookingId } = useParams();

	const { t } = useTranslations();

	const settings = usePaymentSettings();

	const booking = useBookingHistoryDetails(bookingId);

	const isError = settings.isError || booking.isError;

	const isLoading = settings.isLoading || booking.isLoading;

	const isDesktop = useIsDesktop();

	const boxPaddings = {
		py: isDesktop ? 6 : 3,
		px: isDesktop ? 12 : 3,
	};

	if ( isError ) {
		return <Alert severity="error">{t('errors.unknown')}</Alert>;
	}

	if ( isLoading ) {
		return <CircularProgress />;
	}

	return (
		<Paper style={{ width: '100%' }}>
			<Box {...boxPaddings} >
				<PaymentFormContent booking={booking.data.data} />
			</Box>
		</Paper>
	);
};

export default PaymentForm;
